import { render } from "./CardTeam.vue?vue&type=template&id=cec81974&scoped=true"
import script from "./CardTeam.vue?vue&type=script&lang=js"
export * from "./CardTeam.vue?vue&type=script&lang=js"

import "./CardTeam.vue?vue&type=style&index=0&id=cec81974&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cec81974"]])

export default __exports__